import type { TransientJobConfig } from "features/technical-data/scenario/lib/parseTrConfig";

import type { TransientConfigurationFormState } from "../model/transientConfiguration";

import {
  DEFAULT_TRANSIENT_CONFIGURATION,
  findRecalculationMethod,
  findRoomFunctionVariant,
  ROOM_FUNCTION_VARIANT_VALUES,
} from "../model/transientConfiguration";

const resolveRoomFunctionVariant = (value?: string) => {
  if (!value) return DEFAULT_TRANSIENT_CONFIGURATION.room_function_variant;
  const key = findRoomFunctionVariant(value);
  if (key) return ROOM_FUNCTION_VARIANT_VALUES[key];
  const displayValues = Object.values(ROOM_FUNCTION_VARIANT_VALUES);
  if (displayValues.some((item) => item === value)) return value;
  return DEFAULT_TRANSIENT_CONFIGURATION.room_function_variant;
};

export const mapTrConfigToFormState = (
  config: TransientJobConfig,
  availableScenarioIds: number[]
): TransientConfigurationFormState => {
  return {
    delta_time_i: config.delta_time_i ?? DEFAULT_TRANSIENT_CONFIGURATION.delta_time_i,
    dynamic_hvac_start_point:
      config.dynamic_hvac_start_point ?? DEFAULT_TRANSIENT_CONFIGURATION.dynamic_hvac_start_point,
    percentile_to_consider: config.percentile_to_consider ?? DEFAULT_TRANSIENT_CONFIGURATION.percentile_to_consider,
    recalculation_method:
      findRecalculationMethod(config.recalculation_method) ?? DEFAULT_TRANSIENT_CONFIGURATION.recalculation_method,
    room_function_variant: resolveRoomFunctionVariant(config.room_function_variant),
    scenarios: availableScenarioIds,
    t_air_exhaust: config.t_air_exhaust ?? DEFAULT_TRANSIENT_CONFIGURATION.t_air_exhaust,
    time_interval_in_min: config.time_interval_in_min ?? DEFAULT_TRANSIENT_CONFIGURATION.time_interval_in_min,
  };
};
